import type { TNavbarMenuElement } from '@shared/dream-components';
import { NavbarMenu as NavbarMenuElement } from '@shared/dream-components';
import type { ReactNode } from 'react';

interface Props {
  node: TNavbarMenuElement;
  children: ReactNode | ReactNode[];
  screen: 'desktop' | 'mobile';
}

const NavbarMenu = ({ node, children, screen }: Props) => {
  return (
    <NavbarMenuElement element={node} screen={screen}>
      {children}
    </NavbarMenuElement>
  );
};

export default NavbarMenu;
